import { Component } from 'react';
import { connect } from 'react-redux';
import { replace, push, goBack } from 'react-router-redux';
import lodash from 'lodash';

import {
    addApplicationHeaderTitle
} from 'common/actions/applicationHeader';

import {
    loadSdfaInboxItem,
    submitSdfaViewTask,
    clearSdfaItem
} from 'forms/actions/sdfa';

import {
    sortSelector,
    querySelector,
    orderSelector,
} from 'workflow/selectors/inbox';

import { SubFormRouter, SubFormRoute } from 'forms/containers/SubFormRouter/SubFormRouter';
import LoadingComponent from 'common/permissions/components/LoadingComponent';
import SdfaInboxItem from 'forms/components/Sdfa/InboxItem';
import WorkflowDocumentViewer from 'workflow/containers/WorkflowDocumentViewer';

export class SdfaRead extends Component {
    constructor(props) {
        super(props);
        this.state = {
            taskActionSent: false,
            forceRerender: false,
        };
    }

    componentDidMount() {
        this.loadCurrentSdfaItem();
    }

    componentWillUnmount() {
        this.props.clearSdfaItem();
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.pageTitle === null && nextProps.inboxItem) {
            this.props.addApplicationHeaderTitle(nextProps.inboxItem.name);
        }
    }

    componentWillUpdate(nextProps) {
        if (nextProps.taskId !== this.props.taskId) {
            this.props.clearSdfaItem();
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.taskId !== this.props.taskId) {
            this.loadCurrentSdfaItem();
        }
        const { submissionSuccess } = this.props;
        if (submissionSuccess && prevProps.submissionSuccess !== submissionSuccess) {
            this.onSubmissionSuccess();
            this.props.clearSdfaItem();
        }
        if (this.state.forceRerender) {
            this.setState({ forceRerender: false });
        }
    }

    loadCurrentSdfaItem() {
        this.props.loadSdfaInboxItem(this.props.taskId);
    }

    onSubmissionSuccess() {
        const { replace, inboxItem } = this.props;
        const { nextTask } = inboxItem;
        const { sort, order, query, location } = this.props;
        const newLocation = lodash.cloneDeep(location);
        newLocation.query.sort = sort;
        newLocation.query.order = order;
        newLocation.query.q = query;
        delete newLocation.query.subformroute;
        newLocation.pathname = nextTask ? `/form/task/${nextTask}` : '/inbox';
        this.setState({ taskActionSent: false, forceRerender: true });
        replace(newLocation);
    }

    viewDocument() {
        const { push, location } = this.props;
        const updatedLocation = lodash.cloneDeep(location);
        updatedLocation.query.subformroute = 'viewDocument';
        push(updatedLocation);
    }

    readActionSubmit() {
        const {
            inboxItem: { id },
            submitSdfaViewTask
        } = this.props;

        submitSdfaViewTask(id);
    }

    onActionSubmit() {
        this.setState({
            taskActionSent: true
        }, this.readActionSubmit.bind(this));
    }

    render() {
        const { inboxItem, document } = this.props;

        if (this.state.forceRerender || lodash.isNull(inboxItem)) {
            return <LoadingComponent />;
        }

        if (this.state.taskActionSent) {
            const loadingText = 'Completing task ...';
            return (
                <LoadingComponent
                    text={loadingText} />
            );
        }

        return (
            <SubFormRouter data-cy="Read">
                <SubFormRoute>
                    <SdfaInboxItem
                        taskId={this.props.taskId}
                        inboxItem={inboxItem}
                        document={document}
                        onActionClicked={this.onActionSubmit.bind(this)}
                        actionText='Close Task'
                        viewDocument={this.viewDocument.bind(this)} />
                </SubFormRoute>
                <SubFormRoute query="viewDocument">
                    <WorkflowDocumentViewer taskId={this.props.taskId} />
                </SubFormRoute>
            </SubFormRouter>
        );
    }
}

export default connect((state, props) => {
    const inboxItem = lodash.get(state, 'form.inboxItem', null);
    const document = lodash.get(state, 'form.inboxItem.document', null);
    const taskId = lodash.get(props, 'params.id', null);
    const submissionSuccess = lodash.get(state, 'form.submissionSuccess', false);
    const location = props.location;
    const pageTitle = lodash.get(state, 'app.pageTitle', null);

    return {
        inboxItem,
        document,
        taskId,
        pageTitle,
        submissionSuccess,
        location,
        query: querySelector(state),
        sort: sortSelector(state),
        order: orderSelector(state),
    };
}, {
    loadSdfaInboxItem,
    submitSdfaViewTask,
    clearSdfaItem,
    addApplicationHeaderTitle,
    replace,
    push,
    goBack
})(SdfaRead);
